import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import loadingBg from '../../assets/images/loading_bg.png';

const StyledContainer = styled.div`
	position: relative;
	background: #111111;
	width: 100%;
	height: 100%;
	transition: opacity 0.3s ease;

	&.loading-enter {
		opacity: 0;
	}

	&.loading-enter-active,
	&.loading-enter-done,
	&.loading-exit {
		opacity: 1;
	}

	&.loading-exit-active {
		opacity: 0;
	}

	img {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 60px;
		height: 60px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		position: absolute;
		bottom: 40px;
		left: 50%;
		transform: translateX(-50%);
		font-size: 14px;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledBackground = styled.div`
	position: absolute;
	top: -650px;
	left: 50%;
	transform: translateX(-50%);
	width: 1300px;
	height: 1300px;
	mask-image: url(${loadingBg});
	mask-size: cover;
	mask-position: center;
	mask-repeat: no-repeat;
	-webkit-mask-image: url(${loadingBg});
	-webkit-mask-size: cover;
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
`;

export { StyledBackground, StyledContainer };
